import React, { useState } from "react";
// import { Link } from "react-router-dom";
import MenuCards from '../../components/sections/MenuCards';
import { useNavigate } from 'react-router-dom';
import SecondaryBanner from "../../components/sections/SecondaryBanner";
// import PedagogyImg from "../../assets/images/pedagogy_img.png";
import "./style.scss";
import "../../assets/styles/styles.scss";
// import { MENU_CARDS_DATA, ACADEMIC_MENU_DATA } from '../../constants';
import { ACADEMIC_MENU_DATA } from '../../constants';
import CourseData from '../../dummyData/CourseData.json';
import BannerImg from "../../assets/images/AcedmicLife/curriculum_banner.webp";
import SecondImg from "../../assets/images/students/students-studying.webp";

const Curriculum = () => {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState(null);
  const toggleCategory = (category) => {
    setActiveCategory(activeCategory === category ? null : category);
  };

  const handleMenuClick = (route) => {
    if (route.includes("http:") || route.includes("https:")) {
      window.open(route, "_blank")
    } else {
      navigate(`/${route}`);
    }
  }
  return (
    <>
      {/* Section: Banner */}
      <section>
        <SecondaryBanner
          imageUrl={BannerImg}
          title="Academic Life - Curriculum"
          desc="Future-Focused Curriculum"
          themeColor="sh-contentimgsplit--yellow-theme"
        />
      </section>

      {/* Section: Transforming Lives */}
      <section className="global-aboutwrapper">
        <div className="container">
          <div className="row justify-content-md-center">
            <div className="col-12">
              <div className="row">
                <div className="col-md-5 col-12">
                  <h1 className="global-heading">
                    Transformative Curriculum for the Future of Computer Science
                  </h1>
                </div>
                <div className="col-md-7 col-12">
                  <p className="global-bodytext">
                    The newly established Sitare University Program has unveiled an innovative curriculum designed for the evolving demands of the 21st century. This curriculum integrates foundational Computer Science knowledge with cutting-edge fields like Artificial Intelligence, Data Science, Web Development Frameworks, and Information Retrieval. Students will engage in project-based learning, collaborative research, and internships starting from their first year. Our program emphasizes critical thinking, communication skills, and ethical leadership, preparing graduates for diverse, high-paying careers. Additionally, Sitare University Program offers flexible learning paths, personalized mentorship, and a robust support system to foster both academic and personal growth.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section: University Curriculum */}
      <section className="sc-curriculum">
        <div className="container">
          <div className="sc-curriculum--header">
            <h3 className="sc-curriculum--header-text">sitare university curriculum*</h3>
            <a
              href="/curriculum.pdf"
              download="curriculum.pdf"
              className="sc-curriculum--header-btn"
            >
              download curriculum
            </a>
          </div>
          <div className="accordion" id="accordionFlushExample">
            {Object.entries(CourseData).map(([category, courses], index) => (
              <div className="accordion-item cu-enquries--item" key={category}>
                <h2 className="accordion-header cu-enquries--header" id={`flush-heading${index}`}>
                  <button
                    className={`accordion-button cu-enquries--button ${activeCategory === category ? "" : "collapsed"}`}
                    type="button"
                    onClick={() => toggleCategory(category)}
                    aria-expanded={activeCategory === category}
                    aria-controls={`flush-collapse${index}`}
                  >
                    {category}
                  </button>
                </h2>
                <div
                  id={`flush-collapse${index}`}
                  className={`accordion-collapse collapse ${activeCategory === category ? "show" : ""}`}
                  aria-labelledby={`flush-heading${index}`}
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body cu-enquries--body">
                    <ul className="ml-3">
                      {courses.length > 0 ? (
                        [...new Map(
                          courses.filter(course => course && course.name).map(course => [course.name, course])
                        ).values()].map((course, idx) => (
                          <li key={idx} className="project-item">
                            <p className="mt-2">
                              {course.name}
                              {course.code ? ` (${course.code})` : ""}
                            </p>
                          </li>
                        ))
                      ) : (
                        <p>No subjects available</p>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div>* = Subject to Modification</div>
        </div>

      </section>

      {/* Section: Our Philosophy */}
      <section className="global-aboutwrapper pt-5">
        <div className="container">
          <div className="row justify-content-md-center">
            <div className="col-12">
              <div className="row">
                <div className="col-md-5 col-12">
                  <h1 className="global-heading pe-md-3">
                    Bridging Foundational Knowledge with Future-Ready Skills
                  </h1>
                </div>
                <div className="col-md-7 col-12">
                  <p className="global-bodytext">
                    The Computer Science curriculum at Sitare University Program emphasizes both foundational knowledge and emerging technologies. It equips students with a deep understanding of core principles like Data Structures and Programming Methodologies while immersing them in areas such as Artificial Intelligence, Information Retrieval, and Data Analysis. Sitare University Program aims to produce graduates who are technically proficient, ethically conscious, and socially responsible. The curriculum fosters innovation, critical thinking, and problem-solving skills, preparing students to drive technological advancements and address complex global challenges. Emphasizing collaboration, it ensures students can apply computer science principles across various fields, from healthcare to environmental science.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section: Pedagogy Banner */}
      <section className="sc-pedagogybanner">
        <div className="container">
          <img src={SecondImg} alt="Pedagogy" draggable="false" className="sc-pedagogybanner--image" />
        </div>
      </section>

      {/* Section: Pedagogy */}
      <section className="global-aboutwrapper">
        <div className="container">
          <div className="row justify-content-md-center">
            <div className="col-12">
              <div className="row">
                <div className="col-md-5 col-12">
                  <h1 className="global-heading pe-md-3">
                    Integrating Core Knowledge with Emerging Technologies
                  </h1>
                </div>
                <div className="col-md-7 col-12">
                  <p className="global-bodytext">
                    The curriculum also integrates hands-on learning through research projects, internships, and industry collaborations, ensuring practical exposure to real-world challenges. With a focus on interdisciplinary applications, students gain expertise in Search Engines and Information Retrieval, Mathematics for Computing, and Economics for Computer Science. This holistic approach empowers graduates to innovate, lead, and shape the future of technology.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TODO(akshi): Add curriculum related menu cards here */}

      {/* Section: Menu Cards */}
      <section className="global-bgmenucard pt-5">
        <div className='container'>
          <div className="row">
            <div className="col-12">
              <MenuCards data={ACADEMIC_MENU_DATA} handleMenuClick={handleMenuClick} themeColor="sh-menuCard--yellow-theme" />
            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default Curriculum;
